import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { contactEmail } from '../data/content';
export function Guarantee() {
  return <section className="bg-canvas px-4 py-12 md:py-16" data-id="element-78" data-mp="1o33s8bhenif4">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-8 rounded-3xl border border-navy/10 bg-white p-7 text-center shadow-sm md:flex-row md:p-10 md:text-left" data-id="element-79" data-mp="223y4543nw1ij">
        <div className="flex h-36 w-36 shrink-0 flex-col items-center justify-center rounded-full border-4 border-brand-light bg-navy text-white ring-4 ring-brand/15 ring-offset-4" data-id="element-80" data-mp="19eqw9eibhzkm">
          <ShieldCheckIcon className="h-7 w-7 text-brand-light" aria-hidden="true" data-id="element-81" data-mp="14dl4biwhegc5" />
          <span className="font-display text-4xl font-black leading-none" data-id="element-82" data-mp="1j5va2aw9bedv">7</span>
          <span className="mt-1 text-[10px] font-black uppercase tracking-[.15em]" data-id="element-83" data-mp="1ed281us6ak5h">Day guarantee</span>
        </div>
        <div data-id="element-84" data-mp="qmex10myneep">
          <h2 className="font-display text-xl font-black uppercase text-navy md:text-2xl" data-id="element-85" data-mp="qm6kxaynwd4k">7-Day Guarantee</h2>
          <p className="mt-3 text-sm leading-relaxed text-steel" data-id="element-86" data-mp="ozjbwl3tncpo">
            Take a look inside the material, review the volumes and explore how the complete system is organized.
          </p>
          <p className="mt-2 text-sm leading-relaxed text-steel" data-id="element-87" data-mp="tw9srangacc5">
            If you decide that the Complete Injury Rehabilitation Bundle is not what you expected, contact us within 7
            days of purchase at{' '}
            <a href={`mailto:${contactEmail}`} className="font-bold uppercase text-brand underline underline-offset-2" data-id="element-88" data-mp="60xcrbrv7voe">
              {contactEmail}
            </a>{' '}
            and request your refund within the guarantee period.
          </p>
        </div>
      </div>
    </section>;
}